import { Message } from '@ncss/message';
import { BitwiseHelper } from '@ncss/models';
import { ByteList } from 'byte-list';

export enum NL4UpdateMessageType {
  GROUP_MASK = 0x1720,

  MCU = 0x1720,
  MCU_DIFF = 0x1721,
  MCU_COMPRESSED = 0x1722,

  BLE = 0x1723,
  BLE_COMPRESSED = 0x1724,

  RADIO = 0x1725,
  RADIO_DIFF = 0x1726,
  RADIO_COMPRESSED = 0x1727,

  CELL = 0x1728,
  CELL_DIFF = 0x1729,
  CELL_COMPRESSED = 0x172a,
}

export const UPDATE_DATA_SIZE = 2048;

export class NL4UpdateMessage extends Message {
  transferId = 0;
  swd = false;
  deviceTypeId = 33;
  firmwareVersionMajor = 0;
  firmwareVersionMinor = 0;
  totalBlocks = 0;
  currentBlock = 0;
  dataBlock!: Uint8Array;

  constructor(type: NL4UpdateMessageType) {
    super();
    this.type = type;
  }

  serialize(): ByteList {
    const bytes = super.serialize();
    let flags = 0;
    flags = BitwiseHelper.SetBits(flags, 0, 7, this.transferId);
    flags = BitwiseHelper.SetBits(flags, 7, 1, +this.swd);
    bytes.writeByte(flags);
    bytes.writeByte(this.deviceTypeId);
    bytes.writeByte(this.firmwareVersionMajor);
    bytes.writeByte(this.firmwareVersionMinor);
    bytes.writeUInt16(this.totalBlocks);
    bytes.writeUInt16(this.currentBlock);
    for (let i = 0; i < this.dataBlock.byteLength; ++i) {
      bytes.writeByte(this.dataBlock[i]);
    }
    for (let i = this.dataBlock.byteLength; i < UPDATE_DATA_SIZE; ++i) {
      bytes.writeByte(0xff);
    }
    return bytes;
  }

  deserialize(bytes: ByteList): void {
    super.deserialize(bytes);
    const flags = bytes.readByte();
    this.transferId = BitwiseHelper.GetBits(flags, 0, 7);
    this.swd = !!BitwiseHelper.GetBits(flags, 7, 1);
    this.deviceTypeId = bytes.readByte();
    this.firmwareVersionMajor = bytes.readByte();
    this.firmwareVersionMinor = bytes.readByte();
    this.totalBlocks = bytes.readUInt16();
    this.currentBlock = bytes.readUInt16();
    this.dataBlock = bytes.readBytes(UPDATE_DATA_SIZE);
  }
}
